import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import moment from 'moment-timezone';
import { PureComponent } from 'react';
import { PresenceOverlayPopover } from './PresenceOverlayPopover';
class PresenceOverlay extends PureComponent {
    constructor(props) {
        super(props);
        this.onInternalCallClickHandler =
            this.onInternalCallClickHandler.bind(this);
        this._isConnectedToOwnAgent = this._isConnectedToOwnAgent.bind(this);
        this.handlePresenceLinkClick = this.handlePresenceLinkClick.bind(this);
        this.state = {
            internalBtnText: 'Call',
            disabledCall: props.presence.status === 'offline' ||
                props.isOwnAgent === true ||
                props.canMakeInternalCall === false
                ? 'disabled'
                : '',
        };
    }
    onInternalCallClickHandler() {
        if (this.props.canMakeInternalCall === true) {
            this.setState({ internalBtnText: 'Calling...' });
            this.props.internalCall({ userId: this.props.user.id });
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this._isConnectedToOwnAgent(nextProps);
    }
    _isConnectedToOwnAgent(props) {
        var _a;
        let isConnectedWithOwnAgent = false;
        let isInternalCallCalling = false;
        let internalBtnText = 'Call';
        // Agent phone calls.
        const internalCalls = props.presence.presence_status.load_descriptions.filter((o) => o.load_type === 'internalwork' &&
            o.conversation_channel === 'pstnphone');
        // Own internal call.
        const ownInternalCalls = props.ownPresence.presence_status.load_descriptions.filter((o) => o.load_type === 'internalwork' &&
            o.conversation_channel === 'pstnphone');
        // Agent active calls excluding ACW and nonlive.
        const numberOfAgentsActiveCalls = props.presence.presence_status.load_descriptions.filter((o) => (o.conversation_channel === 'pstnphone' ||
            o.conversation_channel === 'callback') &&
            o.load_type !== 'acw' &&
            o.load_type !== 'nonlive').length;
        for (const ownInternalCall of ownInternalCalls) {
            for (const internalCall of internalCalls) {
                if (ownInternalCall.csid === internalCall.csid) {
                    // Internal call with own found.
                    isConnectedWithOwnAgent = true;
                    internalBtnText = 'Connected';
                    if (ownInternalCall.requester !== null &&
                        ownInternalCall.requester.id === this.props.ownProfile.id) {
                        if (((_a = internalCall === null || internalCall === void 0 ? void 0 : internalCall.conversation) === null || _a === void 0 ? void 0 : _a.assignment) !== null) {
                            // Internal was started by own and accepted - we should show connected.
                        }
                        else {
                            // Internal was started by own - we should show calling at btn
                            isInternalCallCalling = true;
                            internalBtnText = 'Connected';
                        }
                        break;
                    }
                    break;
                }
            }
        }
        // Disable if isConnectedWithOwnAgent, is own agent, own agent has a active call or the agent has a call.
        if (props.canMakeInternalCall === false ||
            isConnectedWithOwnAgent === true ||
            props.isOwnAgent === true ||
            numberOfAgentsActiveCalls > 0 ||
            props.presence.status === 'offline' ||
            isInternalCallCalling === true) {
            this.setState({
                disabledCall: 'disabled',
                internalBtnText: internalBtnText,
            });
        }
        else {
            this.setState({ disabledCall: '', internalBtnText: internalBtnText });
        }
    }
    handlePresenceLinkClick(csid) {
        this.props.navigate(`/conversation/${csid}`);
    }
    render() {
        const { presence, hasChannelPhone } = this.props;
        const { presence_status: { load_descriptions }, } = presence;
        const { externalPhoneConversations, nonelivePhoneConversations, chatConversations, messengerConversations, voicemailConversations, emailConversations, contactformConversations, callbackConversations, facebookMessengerConversations, acwConversations, } = load_descriptions.reduce((acc, description) => {
            if (description.conversation_channel === 'pstnphone') {
                switch (description.load_type) {
                    case 'externalwork':
                        acc.externalPhoneConversations.push(description);
                        break;
                    case 'nonlive':
                        acc.nonelivePhoneConversations.push(description);
                        break;
                    case 'internalwork':
                        acc.internalPhoneConversations.push(description);
                        break;
                }
            }
            if (description.load_type === 'acw') {
                acc.acwConversations.push(description);
            }
            // In all other cases filter only by channel
            switch (description.conversation_channel) {
                case 'widgetchat':
                    acc.chatConversations.push(description);
                    break;
                case 'voicemail':
                    acc.voicemailConversations.push(description);
                    break;
                case 'email':
                    acc.emailConversations.push(description);
                    break;
                case 'messenger':
                    acc.messengerConversations.push(description);
                    break;
                case 'facebookmessenger':
                    acc.facebookMessengerConversations.push(description);
                    break;
                case 'contactform':
                    acc.contactformConversations.push(description);
                    break;
                case 'callback':
                    acc.callbackConversations.push(description);
                    break;
            }
            return acc;
        }, {
            externalPhoneConversations: [],
            nonelivePhoneConversations: [],
            internalPhoneConversations: [],
            chatConversations: [],
            messengerConversations: [],
            voicemailConversations: [],
            emailConversations: [],
            contactformConversations: [],
            callbackConversations: [],
            facebookMessengerConversations: [],
            acwConversations: [],
        });
        const numberOfAcw = acwConversations.length;
        let lastSeen = null;
        let acwConversationNode = null;
        if (numberOfAcw > 0) {
            const conversation = numberOfAcw === 1 ? 'conversation' : 'conversations';
            acwConversationNode = (_jsxs("span", { children: ["Wrap-up time on ", numberOfAcw, " ", conversation] }));
        }
        if (this.props.presence.status === 'offline') {
            lastSeen =
                this.props.presence.last_seen === null
                    ? 'Has not signed-in yet'
                    : `Last seen ${moment(this.props.presence.last_seen).fromNow()}`;
        }
        return (_jsx(PresenceOverlayPopover, Object.assign({ user: this.props.user, presence: presence, acwConversationNode: acwConversationNode, hasChannelPhone: hasChannelPhone, lastSeen: lastSeen, ownProfile: this.props.ownProfile, onInternalCallClickHandler: this.onInternalCallClickHandler, meta: this.props.meta, presenceSetOthersSimultaneousRinging: this.props.presenceSetOthersSimultaneousRinging, isOwnAgent: this.props.isOwnAgent, internalBtnText: this.state.internalBtnText, disabledCall: this.state.disabledCall, showUserModal: this.props.showUserModal, conversationsByChannel: {
                clock: acwConversations,
                phone: [...externalPhoneConversations, ...nonelivePhoneConversations],
                chat: chatConversations,
                messenger: messengerConversations,
                voicemail: voicemailConversations,
                mail: emailConversations,
                'chat-widget': contactformConversations,
                callback: callbackConversations,
                'facebook-messenger': facebookMessengerConversations,
            }, handlePresenceLinkClick: this.handlePresenceLinkClick }, { children: this.props.children })));
    }
}
export default PresenceOverlay;
